import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';



function PageNotFound(){
    return(<h1>404 Page not found</h1>);

}


export default PageNotFound;